import SettingsIcon from '@mui/icons-material/Settings';
import StorageIcon from '@mui/icons-material/Storage';
// import DehazeIcon from '@mui/icons-material/Dehaze';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import CasinoIcon from '@mui/icons-material/Casino';
import StarIcon from '@mui/icons-material/Star';

// Resolves relative `/api/admin` in production builds (nginx same-origin proxy).
export { ADMIN_LEGACY_API_URL as serverURL } from '../config/env'
export const menuList = [
    {
        title: 'configuration',
        Icon: SettingsIcon,
        subMenu: [
            {
                title: 'system',
                url: "system"
            },
            {
                title: "languages",
                url: "langs"
            },
            {
                title: "localization",
                url: "locales"
            },
            {
                title: "countries",
                url: "countries"
            },
            {
                title: "classification",
                url: "classification"
            },
            {
                title: "currencies",
                url: "currencies"
            },
            {
                title: "domains",
                url: "domains"
            },
            {
                title: "exchange rates",
                url: "exchange_rates"
            },
            {
                title: 'fast messages',
                url: 'fast_messages'
            },
            {
                title: 'manage labels',
                url: 'manage labels'
            },
            {
                title: "player level list",
                url: "player_level_list"
            },
            {
                title: "terms of use",
                url: "terms"
            },
            {
                title: "upload limits",
                url: "upload_limits"
            }
        ]
    },
    {
        title: "servers",
        Icon: StorageIcon,
        subMenu: [
            {
                title: "cash recovery",
                url: "cash_recovery"
            },
            {
                title: "lobby chat",
                url: "lobby_chat"
            },
            {
                title: "maintenance mode",
                url: "maintenance_mode"
            }
        ]
    },
    {
        title: "skins",
        Icon: SettingsIcon,
    },
    {
        title: "free settings",
        Icon: SettingsIcon,
    },
    {
        title: "users",
        Icon: PeopleAltIcon,
        subMenu: [
            {
                title: "user list",
                url: '/user/list'
            },
            {
                title: "add player level",
                url: '/user/level/add'
            },
            {
                title: "add user",
                url: '/user/add'
            },
            {
                title: "avatars",
                url: "avatars/list"
            },
            {
                title: "blocked users",
                url: "user/blocked-list"
            }
        ]
    },
    {
        title: "backoffice users",
        Icon: SupervisorAccountIcon,
    },
    {
        title: "real time monitoring",
        Icon: DesktopMacIcon,
    },
    {
        title: "tables",
        Icon: CasinoIcon,
        subMenu: [
            {
                title: "Active Tables",
                url: "/table/active"
            },
            {
                title: "Add Table",
                url: "/table/add"
            }
        ]
    },
    {
        title: "tournements",
        Icon: StarIcon,
        subMenu: [
            {
                title: "Tournament list",
                url: "/tournament/list"
            },
            {
                title: "Add Tournament",
                url: "/tournament/add"
            }
        ]
    },
    {
        title: "jackpot",
        Icon: SettingsIcon,
    },
    {
        title: "transaction",
        Icon: SettingsIcon,
    },
    {
        title: "financial reports",
        Icon: SettingsIcon,
    },
    {
        title: "report generation",
        Icon: SettingsIcon,
    },
    {
        title: "action log",
        Icon: SettingsIcon,
    },
    {
        title: "anti fraud",
        Icon: SettingsIcon,
    },
    {
        title: "banner management",
        Icon: SettingsIcon,
    },
    {
        title: "clubs management",
        Icon: SettingsIcon,
    },
    {
        title: "In-App purchases",
        Icon: SettingsIcon,
    },
    {
        title: "notification management",
        Icon: SettingsIcon,
    },
    {
        title: "payment systems",
        Icon: SettingsIcon,
    },
    {
        title: "prohibited users",
        Icon: SettingsIcon,
    },
    {
        title: "promotions management",
        Icon: SettingsIcon,
    },
    {
        title: "reports",
        Icon: SettingsIcon,
    },
]


export const periods = [1, 2, 5, 10];

export const dashboardTabs = [
    {
        title: 'mnt',
        value: 'mnt'
    },
    {
        title: "cgp",
        value: 'cgp'
    },
    {
        title: "ruby",
        value: 'ruby'
    },
    {
        title: "chip",
        value: "chip"
    },
    {
        title: 'club chip',
        value: "club_chip"
    },
    {
        title: "agent credit chip",
        value: 'agent_credit_chip'
    }
]

export const addTableTabs = [
    {
        title: "main",
        value: "main",
    },
    {
        title: 'options',
        value: "options"
    },
    {
        title: "fast fold",
        value: "fastFold"
    },
    {
        title: "ante",
        value: "ante"
    },
    {
        title: "style",
        value: 'style'
    },
    {
        title: "call time",
        value: 'callTime'
    },
    {
        title: "cash drop",
        value: "cashDrop"
    },
    {
        title: "bomb pot",
        value: 'bombPot'
    },
    {
        title: 'squid game',
        value: 'squidGame'
    },
    {
        title: 'seven-deuce',
        value: 'sevenDeuce'
    },
    {
        title: 'cucurucho',
        value: 'cucurucho'
    },
    {
        title: 'attributes',
        value: 'attributes'
    }
]

export const activeTablePeriods = [0, 3, 30, 1 * 60, 2 * 60, 5 * 60, 10 * 60];

export const activeTableHeaders = [
    { label: 'id', value: "id", filterType: "input" },
    { label: "server", value: 'server', filterType: "input" },
    { label: "name", value: "name", filterType: "input" },
    { label: "is club table", value: "isClubTable", filterType: "select" },
    { label: "club ID", value: "clubId", filterType: "input" },
    { label: "pot", value: 'pot', filterType: "select" },
    { label: "game type", value: "gameType", filterType: "select" },
    { label: "Money", value: 'moneyType', filterType: "select" },
    { label: "stakes", value: "stakes", filterType: "input" },
    { label: "balanced mode", value: "balancedMode", filterType: "select" },
    { label: "run it twice mode", value: "runItTwiceMode", filterType: "select" },
    { label: "speed", value: "speed", filterType: "select" },
    { label: "max. plrs", value: "maxPlayer", filterType: "none" },
    { label: "rake-free", value: "forceDisableRake", filterType: "select" },
    { label: "fast fold", value: "fastFold", filterType: "select" },
    { label: "created by user", value: "userCreated", filterType: "select" },
    { label: "created by", value: "creatorId", filterType: "input" },
    { label: "for rent", value: "rent", filterType: "select" }
]